// =============================================================
// VARIANCE — The Executive Command Center
// File      : theme.ts
// Location  : /home/Applications/variance/web/src/lib/theme.ts
// Owner     : VARIANCE frontend application only
// Purpose   : Manages the 8 themes and 3 layout shells.
// =============================================================

export type Theme = 'theme-dark' | 'theme-light' | 'theme-corporate' | 'theme-slate' | 'theme-contrast' | 'theme-purple' | 'theme-forest' | 'theme-sunset';
export type ShellType = 'shell-classic' | 'shell-immersive' | 'shell-topnav';

const ALL_THEMES: Theme[] = [
  'theme-dark', 'theme-light', 'theme-corporate', 'theme-slate', 
  'theme-contrast', 'theme-purple', 'theme-forest', 'theme-sunset'
];

export function applyTheme(theme: Theme) {
  // Remove all existing theme classes
  ALL_THEMES.forEach(t => document.body.classList.remove(t));
  // Add the new theme class
  document.body.classList.add(theme);
  // Save to localStorage
  localStorage.setItem('variance-theme', theme);
  
  // Force a repaint of the DOM to ensure CSS variables update
  document.body.style.display = 'none';
  document.body.offsetHeight; 
  document.body.style.display = '';
}

export function getSavedTheme(): Theme {
  const saved = localStorage.getItem('variance-theme');
  if (saved && ALL_THEMES.includes(saved as Theme)) {
    return saved as Theme;
  }
  return 'theme-dark';
}

export function getSavedShell(): ShellType {
  return (localStorage.getItem('variance-shell') as ShellType) || 'shell-classic';
}

export function saveShell(shell: ShellType) {
  localStorage.setItem('variance-shell', shell);
}
